import React from 'react';
import Calendar from 'v3/common/components/DatePicker/DateRange/Calendar';
import { useSelectState } from 'v3/common/components/DatePicker/DateRange/useSelectState';
import { useFormContext } from 'react-hook-form';
import { RUN_TYPES } from 'v2/common/constants';
import { useDateRange } from 'v3/common/components/DatePicker/DateRange/useDateRange';
import useComponentVisible from 'v3/common/hooks/useComponentVisible';

const DateRange: React.FC = () => {
  const { reduxStart, reduxEnd, pipeConfigs, cases, instrumentGroups, runType } = useSelectState();
  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);
  const { errors, setError, clearErrors } = useFormContext();
  const isHistoric = runType === RUN_TYPES.historic;

  const {
    isShowCustom,
    labelIndex,
    startDate,
    endDate,
    startRange,
    endRange,
    dayDifference,
    setIsShowCustom,
    onCloseRightContent,
    setLabelIndex,
    UNIQUE_ID,
  } = useDateRange({
    isHistoric,
    instrumentGroups,
    cases,
    pipeConfigs,
    setError,
    clearErrors,
    reduxStart,
    reduxEnd,
  });

  return (
    <>
      <label className="label_style">Date</label>
      <div ref={ref} className="date-range-container">
        <div className="wrapper-container">
          <div className="items-center">
            <span>{startRange}</span>
            <span>To</span>
            <span>{endRange}</span>
            <span className="duration">({dayDifference})</span>
          </div>
          <img src="/calendar.png" alt="calendar icon" />
        </div>

        {isComponentVisible && (
          <Calendar
            startDate={startDate}
            endDate={endDate}
            isShowCustom={isShowCustom}
            setIsShowCustom={setIsShowCustom}
            onCloseRightContent={onCloseRightContent}
            setIsComponentVisible={setIsComponentVisible}
            setLabelIndex={setLabelIndex}
            labelIndex={labelIndex}
          />
        )}
      </div>

      {errors[UNIQUE_ID]?.message && (
        <div className="error-message">
          <span>{errors[UNIQUE_ID].message}</span>
        </div>
      )}
    </>
  );
};

export default DateRange;
